import { graphql } from 'react-apollo'
import { ApplicationError } from '../../helpers/errors'
import query from './query.graphql'

export { query }

const DEFAULT_CARDS_PER_PAGE = 12
const DEFAULT_PAGE_NUMBER = 0

function getFields(object, fields) {
  return fields.reduce(
    (obj, field) => Object.assign(obj, { [field]: object[field] }),
    {}
  )
}

function getNestedFields(object, fields) {
  const thing = fields.reduce((obj, field) => {
    const nestedObject = getFields(object, field.values)
    if (
      // eslint-disable-next-line compat/compat
      Object.values(nestedObject).findIndex(value => value === undefined) >= 0
    ) {
      return Object.assign(obj, { [field.name]: undefined })
    } else {
      return Object.assign(obj, { [field.name]: nestedObject })
    }
  }, {})

  return thing
}

export const mapPropsToOptions = ({ filterState }) => {
  const limit = DEFAULT_CARDS_PER_PAGE
  const page = filterState.page || DEFAULT_PAGE_NUMBER

  return {
    errorPolicy: 'ignore',
    variables: {
      path: filterState.categoryPath,
      limit,
      page,
      filters: {
        ...getNestedFields(filterState, [
          { name: 'price', values: ['minPrice', 'maxPrice'] },
        ]),
        ...getFields(filterState, [
          'searchQuery',
          'onSale',
          'color',
          'store',
          'brand',
          'sort',
        ]),
      },
    },
  }
}

const mapFacets = receivedFacets => {
  const retailers = receivedFacets.retailers.map(retailer => ({
    slug: retailer.retailerCode,
    name: retailer.name,
  }))
  return Object.assign({}, receivedFacets, { retailers })
}

export const mapDataToProps = ({
  data: { error, loading, productsForCategoryPath },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  }

  return {
    productsLoading: loading,
    error,
    products: productsForCategoryPath.products,
    pagination: {
      totalItems: productsForCategoryPath.totalItems,
      totalPages: productsForCategoryPath.totalPages,
      page: productsForCategoryPath.page,
    },
    facets: mapFacets(productsForCategoryPath.facets),
  }
}

const withProducts = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withProducts
